// extracted by mini-css-extract-plugin
export default {"root":"ThankYou_root__gSUQx","section":"ThankYou_section__zl4Nu","bold":"ThankYou_bold__ZbU4p"};